import * as Sentry from "@sentry/react";
import { config } from "config";

const SentryService = {
  init: () => {
    console.log("[SentryService] Initializing Sentry...");
    console.log("[SentryService] DSN configured:", config.SENTRY_DSN ? "YES" : "NO");
    console.log("[SentryService] Environment:", config.NODE_ENV || "development");
    
    // Only enable Sentry in production (disable for development, staging, and any other envs)
    const appEnv = (config.APP_ENV || "").toLowerCase();
    const nodeEnv = (config.NODE_ENV || "").toLowerCase();
    const isProduction =
      appEnv === "production" ||
      (appEnv === "" && nodeEnv === "production");

    if (!isProduction) {
      console.log(
        "[SentryService] Non-production environment detected (APP_ENV=",
        appEnv || "undefined",
        ", NODE_ENV=",
        nodeEnv || "undefined",
        "). Skipping Sentry initialization."
      );
      return;
    }
    
    if (!config.SENTRY_DSN) {
      console.warn("[SentryService] Sentry DSN not configured. Skipping Sentry initialization.");
      return;
    }

    try {
      const integrations = [
        Sentry.replayIntegration({
          maskAllText: true,
          blockAllMedia: true,
          maskAllInputs: true,
        }),
      ];

      Sentry.init({
        dsn: config.SENTRY_DSN,
        environment: config?.APP_ENV?.toLowerCase(),
        integrations,
        replaysSessionSampleRate: config?.APP_ENV?.toLowerCase() === "production" ? 0.1 : 1.0,
        replaysOnErrorSampleRate: 1.0,

        beforeSend(event, hint) {
          console.log("[SentryService] Sentry event being sent:", event);
          return event;
        },
      });

      // Set up global error handlers
      window.addEventListener("error", (event) => {
        Sentry.captureException(event.error);
      });

      window.addEventListener("unhandledrejection", (event) => {
        Sentry.captureException(event.reason);
      });

      // Verify Sentry is initialized
      // In Sentry v10+, we can check if client exists using getClient()
      let isInitialized = false;
      try {
        // Try to get the client - newer API for Sentry v10+
        const client = Sentry.getClient();
        isInitialized = client !== null && client !== undefined;
        console.log("[SentryService] Client check result:", client ? "Found" : "Not found");
      } catch (e) {
        console.log("[SentryService] Error checking client:", e);
        // If getClient() doesn't exist, try alternative method
        try {
          // Fallback: try to access the hub
          const hub = (Sentry as any).getCurrentHub?.();
          isInitialized = hub?.getClient?.() !== undefined;
        } catch (e2) {
          // If all checks fail, assume initialized if init() didn't throw
          isInitialized = true;
          console.log("[SentryService] Assuming initialized (init() completed successfully)");
        }
      }
      
      console.log("[SentryService] === Sentry Initialization Status ===");
      console.log("[SentryService] ✓ Sentry initialized:", isInitialized ? "YES" : "NO");
      console.log("[SentryService] ✓ DSN configured:", config.SENTRY_DSN ? "YES" : "NO");
      console.log("[SentryService] ✓ DSN value:", config.SENTRY_DSN ? config.SENTRY_DSN.substring(0, 30) + "..." : "Not set");
      console.log("[SentryService] ✓ Environment:", config?.APP_ENV?.toLowerCase() || "development");
      console.log("[SentryService] ✓ Replay enabled:", integrations.length > 0 ? "YES" : "NO");
      console.log("[SentryService] ================================");
      

    //   try {
    //     Sentry.captureMessage("Sentry test message - initialization successful", "info");
    //     console.log("[SentryService] ✓ Test message sent to Sentry. Check your dashboard!");
    //   } catch (e) {
    //     console.warn("[SentryService] Could not send test message:", e);
    //   }
      
      (window as any).Sentry = Sentry;
      (window as any).SentryService = SentryService;
      console.log("[SentryService] ✓ Sentry is available globally as window.Sentry");
      console.log("[SentryService] ✓ SentryService is available globally as window.SentryService");
      console.log("[SentryService] ✓ Test replay: window.SentryService.testReplay()");
      console.log("[SentryService] ✓ Test error: window.Sentry.captureException(new Error('Test'))");
      
      if (!isInitialized) {
        console.warn("[SentryService] ⚠ Initialization check failed, but Sentry may still be working. Try: window.Sentry.captureException(new Error('Test'))");
      }
    } catch (error) {
      console.error("[SentryService] Failed to initialize Sentry:", error);
    }
  },
};

export default SentryService;

